import React from 'react';
import { Container, Card, Row, Col, Button } from 'react-bootstrap';
import { useAuth } from '../../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  return (
    <Container className="mt-5">
      <Row>
        <Col md={8} className="mx-auto">
          <Card>
            <Card.Header as="h2" className="bg-success text-white">
              Authenticated Dashboard
            </Card.Header>
            <Card.Body>
              <h4>Welcome, {currentUser?.displayName || 'User'}!</h4>
              
              <div className="my-4">
                <h5>Your Profile Information:</h5>
                <ul className="list-unstyled">
                  <li><strong>Email:</strong> {currentUser?.email}</li>
                  <li>
                    <strong>Email Verified:</strong>{' '}
                    {currentUser?.emailVerified ? (
                      <span className="text-success">✓ Yes</span>
                    ) : (
                      <span className="text-warning">⚠ No</span>
                    )}
                  </li>
                  {/* <li><strong>User ID:</strong> {currentUser?.uid}</li>
                  <li><strong>Provider:</strong> {currentUser?.providerData[0]?.providerId}</li> */}
                </ul>
              </div>

              {currentUser?.photoURL && (
                <div className="my-3">
                  <img 
                    src={currentUser.photoURL} 
                    alt="Profile" 
                    className="rounded-circle"
                    style={{ width: '100px', height: '100px' }}
                  />
                </div>
              )}

              <div className="alert alert-info" role="alert">
                <strong>🎉 Success!</strong> This is a protected page that only authenticated users can see.
                <br/>
                <strong>Your intrepid curiosity has led you here! </strong><br/>
                <p>Soon we will have free, members-only gaming materials available such as:<br/>
                <strong>The Districts of Doskvol for Blades in the Dark</strong>.<br/>
                We will notify members when new materials are available. Thank you, and watch for Smoke Raven up above.</p>

              </div>

              <div className="d-flex gap-2">
                <Button variant="primary" onClick={() => navigate('/')}>
                  Go to Home
                </Button>
                <Button variant="outline-danger" onClick={handleLogout}>
                  Sign Out
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
